import { Injectable } from '@angular/core';

@Injectable()
export class AuthenticationServiceMock {
    private loggedIn = false;

    authenticate(userId: string, password: string) {}

    isLoggedIn(): boolean {
        return this.loggedIn;
    }

    logout(): void {
        this.loggedIn = false;
    }

    getToken(): void {
        return null;
    }

    getCookie(): void {
        return null;
    }
}
